export const SNACKBAR_TEXT = {
  INFO_SAVED: "Info saved!",
  VALUE_PROPS_GENERATED: "Value Props generated!",
};
